export function validMinDate(field) {
    let day, month, year;
    let min_day, min_month, min_year;
    const date = field.value.split("-");
    const min = field.getAttribute("data-date-min").split("-");
    const format = field.getAttribute("data-date-format") || "YYYY-MM-DD";

    if (format == "YYYY-MM-DD") {
        year = date[0];
        month = date[1];
        day = date[2];

        min_year = min[0];
        min_month = min[1];
        min_day = min[2];
    }

    return Date.UTC(year, month, day) >= Date.UTC(min_year, min_month, min_day);
}
